import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';

const DirectorioLanding = () => {
    const history = useHistory();
    const { userPermissions } = useMantenedores();
    const permisos = userPermissions?.modules?.directorio || {};

    const navigateToConductores = () => {
        history.push('/mantenedores/directorio/conductores');
    };

    const navigateToVehiculos = () => {
        history.push('/mantenedores/directorio/vehiculos');
    };

    return (
        <SimpleMantenedorLayout
            mantenedorId="directorio"
            title="Mantenedor de Directorio"
            subtitle="Sistema de gestión de conductores y vehículos"
            iconColor="#28a745"
            showBackButton={false}
            breadcrumbs={[
                {
                    label: 'Directorio'
                }
            ]}
        >
            <Row className="mt-4">
                <Col xs={12}>
                    <div style={{ marginBottom: '24px' }}>
                        <h4 style={{ color: '#212529', marginBottom: '8px' }}>
                            Gestión de Directorio
                        </h4>
                        <p style={{ color: '#6c757d', marginBottom: '0' }}>
                            Selecciona el módulo del directorio que deseas gestionar
                        </p>
                    </div>
                </Col>
            </Row>

            <Row className="g-4">
                {/* Conductores */}
                <Col xs={12} md={6} lg={6}>
                    <Card 
                        style={{ 
                            height: '200px',
                            cursor: 'pointer',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            border: '1px solid #dee2e6'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                        }}
                        onClick={navigateToConductores}
                    >
                        <Card.Body className="d-flex flex-column justify-content-center align-items-center text-center">
                            <div style={{
                                backgroundColor: '#17a2b8',
                                color: 'white',
                                width: '60px',
                                height: '60px',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '16px',
                                fontSize: '1.5rem'
                            }}>
                                <FaIcons.FaUsers />
                            </div>
                            <h5 style={{ color: '#212529', marginBottom: '8px', fontWeight: '600' }}>
                                Conductores
                            </h5>
                            <p style={{ color: '#6c757d', fontSize: '14px', marginBottom: '0' }}>
                                Gestión de conductores registrados en el sistema
                            </p>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Vehículos */}
                <Col xs={12} md={6} lg={6}>
                    <Card 
                        style={{ 
                            height: '200px',
                            cursor: 'pointer',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            border: '1px solid #dee2e6'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                        }}
                        onClick={navigateToVehiculos}
                    >
                        <Card.Body className="d-flex flex-column justify-content-center align-items-center text-center">
                            <div style={{
                                backgroundColor: '#28a745',
                                color: 'white',
                                width: '60px',
                                height: '60px',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '16px',
                                fontSize: '1.5rem'
                            }}>
                                <FaIcons.FaTruck />
                            </div>
                            <h5 style={{ color: '#212529', marginBottom: '8px', fontWeight: '600' }}>
                                Vehículos
                            </h5>
                            <p style={{ color: '#6c757d', fontSize: '14px', marginBottom: '0' }}>
                                Gestión de vehículos y flota de transporte
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </SimpleMantenedorLayout>
    );
};

export default DirectorioLanding;
